/**
 * CATÁLOGO DE RECETAS AGNÓSTICAS — las 8 ruedas de LotoWheel como DATOS PUROS.
 *
 * Plano: docs/MODELO_RECETA_AGNOSTICA.md. Cero cómputo: cada receta se lee, no
 * se materializa. Reemplaza la cadena construirRueda + reglasDeProps +
 * derivarConfigSSOT — el motor que derivaba grupos/arcos en runtime.
 *
 * 3 DIMENSIONES independientes que se cruzan por `valor`:
 *
 *   sectores[]        la rueda física. Por quesito:
 *     valor           identidad money-path (índice del escenario). NUNCA se muestra.
 *     bot             cara del sector (número, equipo, "10+1").
 *     top             etiqueta superior (los sectores fuera de grilla la llevan).
 *     grad            icono/gradiente del quesito (null = color plano).
 *     paleta          clave de paleta del tema (el color visible sale del tema).
 *     peso            unidades angulares. 1 = uniforme; el arco se calcula al pintar.
 *
 *   apuestas[]        paytable + stats + resolver. Cada apuesta declara su
 *                     cobertura y su multiplicador propios. Si dos coberturas
 *                     distintas pagan distinto, son dos apuestas distintas.
 *                     Cero overrides por sector. Por apuesta:
 *     id              identificador agnostico arbitrario (rojos, docena1, bloqueA,
 *                     aciertoDirecto, argentina, ...).
 *     grupo           categoria de agrupamiento (color, paridad, mitad, tercios,
 *                     columnas, bloques, gemelos, espejos, directo, duo, linea,
 *                     cuadra, dobleLinea, pais, ...). Lo elige la receta.
 *     sectores        array de valores que cubre — apuesta FIJA.
 *     aridad          cantidad de numeros que el jugador elige — apuesta GEOMETRICA.
 *     multiplicador   pago global (numerico, > 0).
 *     categoria       "inside" | "outside".
 *     autorizable     el admin puede activarla/desactivarla.
 *     activa          estado actual (lo que el producto ofrece hoy).
 *
 *   mat               cómo se apuesta:
 *     columnas        ancho de la grilla numérica.
 *     botones[]       {linea, seccion, spanColumnas?} — cada botón apunta
 *                     a una línea de premio. seccion declara dónde se
 *                     pinta en el layout (6 secciones físicas):
 *                       superior  — fila 1 del grid, span columnas (LOTO/cero).
 *                                   Lleva `spanColumnas` (por defecto = mat.columnas).
 *                       lateral   — columna derecha del grid (docenas/tercios).
 *                       inferior  — fila bajo del grid, una por columna (columnas).
 *                       chance    — panel chance-hub (rojo/negro/par/impar/alto/bajo).
 *                       special   — panel mat-special (bloques/gemelos/espejos).
 *                     Las apuestas de gesture (duo, linea, cuadra, dobleLinea)
 *                     no necesitan boton — el gesture controller las detecta
 *                     al arrastrar entre celdas adyacentes de la grilla.
 *                     filas/numeros/filaDelCero se derivan en el lector.
 *     bordesApostables {gesto: bool}? — opcional. Gates declarativos para
 *                     gestos geométricos que el resolver emite. Ausente o
 *                     `true` = activo (retrocompat). Catálogo de gestos:
 *                       duoEntreSuperiorYDirectaInterior: caballo (duo) entre
 *                         un botón de la fila superior (cero/LOTO) y una
 *                         apuesta directa interior de la fila 0. Útil cuando
 *                         los sectores superiores son adyacentes a una
 *                         directa en la rueda real (european: cero pegado al
 *                         1/2/3). Apagar cuando la fila superior es un botón
 *                         único agrupado y sus sectores no colindan con una
 *                         directa específica (ej. rueda10: los dos LOTOs no
 *                         son adyacentes a ningún número particular del mat).
 *
 * FUENTE DIRECTA. Se edita a mano — es el SSOT de las recetas. (Nació de un
 * master 331/331 ancla la equivalencia money-path tras cada cambio de datos.
 *
 * shared/ es ESM. El backend (CJS) lo importa con require (Node 22).
 */

import { LIGHTNING_PRESETS } from './lightning-presets.js';

export const RECETAS_AGNOSTICAS = {
    european: {
        id: 'european',
        fontFamily: 'RouletteNumbers, Arial, sans-serif',
        sectores: [
            {
                valor: 0,
                bot: 37,
                top: 'LOTO',
                grad: null,
                peso: 1,
                excluidoDeHotCold: true,
                paleta: 'paleta-2',
            },
            { valor: 32, bot: 32, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 15, bot: 15, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 19, bot: 19, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 4, bot: 4, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 21, bot: 21, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 2, bot: 2, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 25, bot: 25, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 17, bot: 17, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 34, bot: 34, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 6, bot: 6, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 27, bot: 27, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 13, bot: 13, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 36, bot: 36, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 11, bot: 11, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 30, bot: 30, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 8, bot: 8, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 23, bot: 23, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 10, bot: 10, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 5, bot: 5, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 24, bot: 24, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 16, bot: 16, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 33, bot: 33, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 1, bot: 1, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 20, bot: 20, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 14, bot: 14, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 31, bot: 31, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 9, bot: 9, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 22, bot: 22, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 18, bot: 18, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 29, bot: 29, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 7, bot: 7, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 28, bot: 28, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 12, bot: 12, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 35, bot: 35, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 3, bot: 3, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 26, bot: 26, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
        ],
        apuestas: [
            // GEOMÉTRICAS (canal wallet; el jugador las arma tocando la grilla 3×12).
            {
                id: 'aciertoDirecto',
                grupo: 'directo',
                aridad: 1,
                multiplicador: 36,
                categoria: 'inside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'duo',
                grupo: 'duo',
                aridad: 2,
                multiplicador: 18,
                categoria: 'inside',
                autorizable: true,
                activa: true,
                canales: ['wallet'],
            },
            {
                id: 'linea',
                grupo: 'linea',
                aridad: 3,
                multiplicador: 12,
                categoria: 'inside',
                autorizable: true,
                activa: true,
                canales: ['wallet'],
            },
            {
                id: 'cuadra',
                grupo: 'cuadra',
                aridad: 4,
                multiplicador: 9,
                categoria: 'inside',
                autorizable: true,
                activa: true,
                canales: ['wallet'],
            },
            {
                id: 'dobleLinea',
                grupo: 'dobleLinea',
                aridad: 6,
                multiplicador: 6,
                categoria: 'inside',
                autorizable: true,
                activa: true,
                canales: ['wallet'],
            },
            // FIJAS inside del cero (botón en grilla; no se arman por geometría).
            // El cero acierto directo paga x36 = grupo 'directo' (fila NUMERO).
            // FIJAS outside — características.
            {
                id: 'rojos',
                grupo: 'color',
                sectores: [32, 19, 21, 25, 34, 27, 36, 30, 23, 5, 16, 1, 14, 9, 18, 7, 12, 3],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'negros',
                grupo: 'color',
                sectores: [15, 4, 2, 17, 6, 13, 11, 8, 10, 24, 33, 20, 31, 22, 29, 28, 35, 26],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'pares',
                grupo: 'paridad',
                sectores: [32, 4, 2, 34, 6, 36, 30, 8, 10, 24, 16, 20, 14, 22, 18, 28, 12, 26],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'impares',
                grupo: 'paridad',
                sectores: [15, 19, 21, 25, 17, 27, 13, 11, 23, 5, 33, 1, 31, 9, 29, 7, 35, 3],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bajos',
                grupo: 'mitad',
                sectores: [15, 4, 2, 17, 6, 13, 11, 8, 10, 5, 16, 1, 14, 9, 18, 7, 12, 3],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'altos',
                grupo: 'mitad',
                sectores: [32, 19, 21, 25, 34, 27, 36, 30, 23, 24, 33, 20, 31, 22, 29, 28, 35, 26],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'docena1',
                grupo: 'tercios',
                sectores: [4, 2, 6, 11, 8, 10, 5, 1, 9, 7, 12, 3],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'docena2',
                grupo: 'tercios',
                sectores: [15, 19, 21, 17, 13, 23, 24, 16, 20, 14, 22, 18],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'docena3',
                grupo: 'tercios',
                sectores: [32, 25, 34, 27, 36, 30, 33, 31, 29, 28, 35, 26],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'columna1',
                grupo: 'columnas',
                sectores: [19, 4, 25, 34, 13, 10, 16, 1, 31, 22, 7, 28],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'columna2',
                grupo: 'columnas',
                sectores: [32, 2, 17, 11, 8, 23, 5, 20, 14, 29, 35, 26],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'columna3',
                grupo: 'columnas',
                sectores: [15, 21, 6, 27, 36, 30, 24, 33, 9, 18, 12, 3],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            // FIJAS especiales (botón zona 'especial' → sección PREMIOS ESPECIALES).
            {
                id: 'bloqueA',
                grupo: 'bloques',
                sectores: [32, 15, 19, 4, 21, 2],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueB',
                grupo: 'bloques',
                sectores: [25, 17, 34, 6, 27, 13],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueC',
                grupo: 'bloques',
                sectores: [36, 11, 30, 8, 23, 10],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueD',
                grupo: 'bloques',
                sectores: [5, 24, 16, 33, 1, 20],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueE',
                grupo: 'bloques',
                sectores: [14, 31, 9, 22, 18, 29],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueF',
                grupo: 'bloques',
                sectores: [7, 28, 12, 35, 3, 26],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'gemelos',
                grupo: 'gemelos',
                sectores: [11, 22, 33],
                multiplicador: 12,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'espejo_12_21',
                grupo: 'espejos',
                sectores: [12, 21],
                multiplicador: 18,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'espejo_13_31',
                grupo: 'espejos',
                sectores: [13, 31],
                multiplicador: 18,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'espejo_23_32',
                grupo: 'espejos',
                sectores: [23, 32],
                multiplicador: 18,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
        ],
        barrasDeStats: [
            { tipo: 'binaria', grupo: 'color', lineas: ['rojos', 'negros'] },
            { tipo: 'binaria', grupo: 'paridad', lineas: ['impares', 'pares'] },
            { tipo: 'binaria', grupo: 'mitad', lineas: ['bajos', 'altos'] },
            { tipo: 'stacked', grupo: 'tercios', lineas: ['docena1', 'docena2', 'docena3'] },
            { tipo: 'stacked', grupo: 'columnas', lineas: ['columna1', 'columna2', 'columna3'] },
            {
                tipo: 'stacked',
                grupo: 'bloques',
                lineas: ['bloqueA', 'bloqueB', 'bloqueC', 'bloqueD', 'bloqueE', 'bloqueF'],
            },
        ],
        mat: {
            columnas: 3,
            botones: [
                { linea: 'docena1', seccion: 'lateral', paleta: 'paleta-6', tipografia: 'tercio' },
                { linea: 'docena2', seccion: 'lateral', paleta: 'paleta-8', tipografia: 'tercio' },
                { linea: 'docena3', seccion: 'lateral', paleta: 'paleta-2', tipografia: 'tercio' },
                { linea: 'columna1', seccion: 'inferior', paleta: 'paleta-9', tipografia: 'columna' },
                { linea: 'columna2', seccion: 'inferior', paleta: 'paleta-10', tipografia: 'columna' },
                { linea: 'columna3', seccion: 'inferior', paleta: 'paleta-11', tipografia: 'columna' },
                { linea: 'rojos', seccion: 'chance', paleta: 'paleta-0', tipografia: 'enfasis' },
                { linea: 'negros', seccion: 'chance', paleta: 'paleta-1', tipografia: 'enfasis' },
                { linea: 'pares', seccion: 'chance', paleta: 'paleta-9', tipografia: 'chance' },
                { linea: 'impares', seccion: 'chance', paleta: 'paleta-12', tipografia: 'chance' },
                { linea: 'bajos', seccion: 'chance', paleta: 'paleta-7', tipografia: 'chance' },
                { linea: 'altos', seccion: 'chance', paleta: 'paleta-5', tipografia: 'chance' },
                { linea: 'bloqueA', seccion: 'special', paleta: 'paleta-4', tipografia: 'especial' },
                { linea: 'bloqueB', seccion: 'special', paleta: 'paleta-3', tipografia: 'especial' },
                { linea: 'bloqueC', seccion: 'special', paleta: 'paleta-4', tipografia: 'especial' },
                { linea: 'bloqueD', seccion: 'special', paleta: 'paleta-3', tipografia: 'especial' },
                { linea: 'bloqueE', seccion: 'special', paleta: 'paleta-4', tipografia: 'especial' },
                { linea: 'bloqueF', seccion: 'special', paleta: 'paleta-3', tipografia: 'especial' },
                { linea: 'gemelos', seccion: 'special', paleta: 'paleta-8', tipografia: 'especial' },
                {
                    linea: 'espejo_12_21',
                    seccion: 'special',
                    paleta: 'paleta-5',
                    tipografia: 'especial',
                    tituloI18nKey: 'lineas.espejos',
                },
                {
                    linea: 'espejo_13_31',
                    seccion: 'special',
                    paleta: 'paleta-10',
                    tipografia: 'especial',
                    tituloI18nKey: 'lineas.espejos',
                },
                {
                    linea: 'espejo_23_32',
                    seccion: 'special',
                    paleta: 'paleta-11',
                    tipografia: 'especial',
                    tituloI18nKey: 'lineas.espejos',
                },
            ],
        },
        geometria: {
            radioInterior: 0.35,
            radioMedio: 0.6,
            radioExterior: 0.98,
            alturaDomo: 0.09, // casquete SUAVE, apenas más alto que el relieve central
            // El tramo del domo (r=0 hasta radioInterior) NO se declara acá — lo
            // calcula resolverPuntosDePerfil() desde alturaDomo (geometría del
            // casquete esférico, empalme garantizado por código, no por un z a mano).
            // El primer punto de este array es el primero DESPUÉS del domo.
            perfilRelieve: [
                { r: 0.475, z: -0.05 },
                { r: 'radioMedio', z: 0 },
                { r: 'radioExterior', z: 0.055 },
                { r: 1, z: 0 },
            ],
        },
    },

    mega3000: {
        id: 'mega3000',
        fontFamily: 'RouletteNumbers, Arial, sans-serif',
        sectores: [
            {
                valor: 0,
                bot: 37,
                top: 'LOTO',
                grad: null,
                peso: 1,
                excluidoDeHotCold: true,
                paleta: 'paleta-2',
            },
            { valor: 32, bot: 32, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 15, bot: 15, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 19, bot: 19, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 4, bot: 4, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 21, bot: 21, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 2, bot: 2, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 25, bot: 25, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 17, bot: 17, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 34, bot: 34, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 6, bot: 6, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 27, bot: 27, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 13, bot: 13, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 36, bot: 36, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 11, bot: 11, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 30, bot: 30, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 8, bot: 8, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 23, bot: 23, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 10, bot: 10, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 5, bot: 5, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 24, bot: 24, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 16, bot: 16, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 33, bot: 33, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 1, bot: 1, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 20, bot: 20, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 14, bot: 14, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 31, bot: 31, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 9, bot: 9, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 22, bot: 22, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 18, bot: 18, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 29, bot: 29, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 7, bot: 7, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 28, bot: 28, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 12, bot: 12, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 35, bot: 35, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 3, bot: 3, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 26, bot: 26, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
        ],
        apuestas: [
            // GEOMÉTRICAS (canal wallet; el jugador las arma tocando la grilla 3×12).
            {
                id: 'aciertoDirecto',
                grupo: 'directo',
                aridad: 1,
                multiplicador: 20, // recortado (réplica Mega 3000: pago normal ya es el recortado)
                categoria: 'inside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'duo',
                grupo: 'duo',
                aridad: 2,
                multiplicador: 18,
                categoria: 'inside',
                autorizable: true,
                activa: true,
                canales: ['wallet'],
            },
            {
                id: 'linea',
                grupo: 'linea',
                aridad: 3,
                multiplicador: 12,
                categoria: 'inside',
                autorizable: true,
                activa: true,
                canales: ['wallet'],
            },
            {
                id: 'cuadra',
                grupo: 'cuadra',
                aridad: 4,
                multiplicador: 9,
                categoria: 'inside',
                autorizable: true,
                activa: true,
                canales: ['wallet'],
            },
            {
                id: 'dobleLinea',
                grupo: 'dobleLinea',
                aridad: 6,
                multiplicador: 6,
                categoria: 'inside',
                autorizable: true,
                activa: true,
                canales: ['wallet'],
            },
            // FIJAS inside del cero (botón en grilla; no se arman por geometría).
            // El cero acierto directo paga x20 (pleno recortado de esta receta — financia el lightning).
            // FIJAS outside — características.
            {
                id: 'rojos',
                grupo: 'color',
                sectores: [32, 19, 21, 25, 34, 27, 36, 30, 23, 5, 16, 1, 14, 9, 18, 7, 12, 3],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'negros',
                grupo: 'color',
                sectores: [15, 4, 2, 17, 6, 13, 11, 8, 10, 24, 33, 20, 31, 22, 29, 28, 35, 26],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'pares',
                grupo: 'paridad',
                sectores: [32, 4, 2, 34, 6, 36, 30, 8, 10, 24, 16, 20, 14, 22, 18, 28, 12, 26],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'impares',
                grupo: 'paridad',
                sectores: [15, 19, 21, 25, 17, 27, 13, 11, 23, 5, 33, 1, 31, 9, 29, 7, 35, 3],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bajos',
                grupo: 'mitad',
                sectores: [15, 4, 2, 17, 6, 13, 11, 8, 10, 5, 16, 1, 14, 9, 18, 7, 12, 3],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'altos',
                grupo: 'mitad',
                sectores: [32, 19, 21, 25, 34, 27, 36, 30, 23, 24, 33, 20, 31, 22, 29, 28, 35, 26],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'docena1',
                grupo: 'tercios',
                sectores: [4, 2, 6, 11, 8, 10, 5, 1, 9, 7, 12, 3],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'docena2',
                grupo: 'tercios',
                sectores: [15, 19, 21, 17, 13, 23, 24, 16, 20, 14, 22, 18],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'docena3',
                grupo: 'tercios',
                sectores: [32, 25, 34, 27, 36, 30, 33, 31, 29, 28, 35, 26],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'columna1',
                grupo: 'columnas',
                sectores: [19, 4, 25, 34, 13, 10, 16, 1, 31, 22, 7, 28],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'columna2',
                grupo: 'columnas',
                sectores: [32, 2, 17, 11, 8, 23, 5, 20, 14, 29, 35, 26],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'columna3',
                grupo: 'columnas',
                sectores: [15, 21, 6, 27, 36, 30, 24, 33, 9, 18, 12, 3],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            // FIJAS especiales (botón zona 'especial' → sección PREMIOS ESPECIALES).
            {
                id: 'bloqueA',
                grupo: 'bloques',
                sectores: [32, 15, 19, 4, 21, 2],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueB',
                grupo: 'bloques',
                sectores: [25, 17, 34, 6, 27, 13],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueC',
                grupo: 'bloques',
                sectores: [36, 11, 30, 8, 23, 10],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueD',
                grupo: 'bloques',
                sectores: [5, 24, 16, 33, 1, 20],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueE',
                grupo: 'bloques',
                sectores: [14, 31, 9, 22, 18, 29],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueF',
                grupo: 'bloques',
                sectores: [7, 28, 12, 35, 3, 26],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'gemelos',
                grupo: 'gemelos',
                sectores: [11, 22, 33],
                multiplicador: 12,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'espejo_12_21',
                grupo: 'espejos',
                sectores: [12, 21],
                multiplicador: 18,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'espejo_13_31',
                grupo: 'espejos',
                sectores: [13, 31],
                multiplicador: 18,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'espejo_23_32',
                grupo: 'espejos',
                sectores: [23, 32],
                multiplicador: 18,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
        ],
        barrasDeStats: [
            { tipo: 'binaria', grupo: 'color', lineas: ['rojos', 'negros'] },
            { tipo: 'binaria', grupo: 'paridad', lineas: ['impares', 'pares'] },
            { tipo: 'binaria', grupo: 'mitad', lineas: ['bajos', 'altos'] },
            { tipo: 'stacked', grupo: 'tercios', lineas: ['docena1', 'docena2', 'docena3'] },
            { tipo: 'stacked', grupo: 'columnas', lineas: ['columna1', 'columna2', 'columna3'] },
            {
                tipo: 'stacked',
                grupo: 'bloques',
                lineas: ['bloqueA', 'bloqueB', 'bloqueC', 'bloqueD', 'bloqueE', 'bloqueF'],
            },
        ],
        mat: {
            columnas: 3,
            botones: [
                { linea: 'docena1', seccion: 'lateral', paleta: 'paleta-6', tipografia: 'tercio' },
                { linea: 'docena2', seccion: 'lateral', paleta: 'paleta-8', tipografia: 'tercio' },
                { linea: 'docena3', seccion: 'lateral', paleta: 'paleta-2', tipografia: 'tercio' },
                { linea: 'columna1', seccion: 'inferior', paleta: 'paleta-9', tipografia: 'columna' },
                { linea: 'columna2', seccion: 'inferior', paleta: 'paleta-10', tipografia: 'columna' },
                { linea: 'columna3', seccion: 'inferior', paleta: 'paleta-11', tipografia: 'columna' },
                { linea: 'rojos', seccion: 'chance', paleta: 'paleta-0', tipografia: 'enfasis' },
                { linea: 'negros', seccion: 'chance', paleta: 'paleta-1', tipografia: 'enfasis' },
                { linea: 'pares', seccion: 'chance', paleta: 'paleta-9', tipografia: 'chance' },
                { linea: 'impares', seccion: 'chance', paleta: 'paleta-12', tipografia: 'chance' },
                { linea: 'bajos', seccion: 'chance', paleta: 'paleta-7', tipografia: 'chance' },
                { linea: 'altos', seccion: 'chance', paleta: 'paleta-5', tipografia: 'chance' },
                { linea: 'bloqueA', seccion: 'special', paleta: 'paleta-4', tipografia: 'especial' },
                { linea: 'bloqueB', seccion: 'special', paleta: 'paleta-3', tipografia: 'especial' },
                { linea: 'bloqueC', seccion: 'special', paleta: 'paleta-4', tipografia: 'especial' },
                { linea: 'bloqueD', seccion: 'special', paleta: 'paleta-3', tipografia: 'especial' },
                { linea: 'bloqueE', seccion: 'special', paleta: 'paleta-4', tipografia: 'especial' },
                { linea: 'bloqueF', seccion: 'special', paleta: 'paleta-3', tipografia: 'especial' },
                { linea: 'gemelos', seccion: 'special', paleta: 'paleta-8', tipografia: 'especial' },
                {
                    linea: 'espejo_12_21',
                    seccion: 'special',
                    paleta: 'paleta-5',
                    tipografia: 'especial',
                    tituloI18nKey: 'lineas.espejos',
                },
                {
                    linea: 'espejo_13_31',
                    seccion: 'special',
                    paleta: 'paleta-10',
                    tipografia: 'especial',
                    tituloI18nKey: 'lineas.espejos',
                },
                {
                    linea: 'espejo_23_32',
                    seccion: 'special',
                    paleta: 'paleta-11',
                    tipografia: 'especial',
                    tituloI18nKey: 'lineas.espejos',
                },
            ],
        },
        geometria: {
            radioInterior: 0.35,
            radioMedio: 0.6,
            radioExterior: 0.98,
            alturaDomo: 0.09, // casquete SUAVE, apenas más alto que el relieve central
            // El tramo del domo (r=0 hasta radioInterior) NO se declara acá — lo
            // calcula resolverPuntosDePerfil() desde alturaDomo (geometría del
            // casquete esférico, empalme garantizado por código, no por un z a mano).
            // El primer punto de este array es el primero DESPUÉS del domo.
            perfilRelieve: [
                { r: 0.475, z: -0.05 },
                { r: 'radioMedio', z: 0 },
                { r: 'radioExterior', z: 0.055 },
                { r: 1, z: 0 },
            ],
        },
        // LIGHTNING — réplica Mega Roulette 3000 (Pragmatic). Rueda propia, NO la european
        // normal: el pleno de esta receta YA es el recortado (20, arriba en apuestas.aciertoDirecto).
        // Modelo: lightning-modelo-canonico.md. DESACTIVADO hasta validar Monte Carlo + code-review.
        lightning: {
            ...LIGHTNING_PRESETS.mega3000,
            activo: false, // DESACTIVADO hasta validar Monte Carlo + code-review (money-path)
        },
    },

    american: {
        id: 'american',
        fontFamily: 'RouletteNumbers, Arial, sans-serif',
        sectores: [
            {
                valor: 0,
                bot: 37,
                top: 'LOTO',
                grad: null,
                peso: 1,
                excluidoDeHotCold: true,
                paleta: 'paleta-2',
            },
            { valor: 28, bot: 28, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 9, bot: 9, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 26, bot: 26, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 30, bot: 30, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 11, bot: 11, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 7, bot: 7, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 20, bot: 20, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 32, bot: 32, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 17, bot: 17, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 5, bot: 5, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 22, bot: 22, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 34, bot: 34, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 15, bot: 15, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 3, bot: 3, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 24, bot: 24, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 36, bot: 36, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 13, bot: 13, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 1, bot: 1, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            {
                valor: 37,
                bot: 38,
                top: 'LOTO',
                grad: null,
                peso: 1,
                excluidoDeHotCold: true,
                paleta: 'paleta-2',
            },
            { valor: 27, bot: 27, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 10, bot: 10, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 25, bot: 25, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 29, bot: 29, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 12, bot: 12, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 8, bot: 8, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 19, bot: 19, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 31, bot: 31, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 18, bot: 18, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 6, bot: 6, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 21, bot: 21, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 33, bot: 33, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 16, bot: 16, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 4, bot: 4, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 23, bot: 23, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 35, bot: 35, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 14, bot: 14, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 2, bot: 2, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
        ],
        apuestas: [
            // GEOMÉTRICAS (canal wallet; el jugador las arma tocando la grilla 3×12).
            {
                id: 'aciertoDirecto',
                grupo: 'directo',
                aridad: 1,
                multiplicador: 36,
                categoria: 'inside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'duo',
                grupo: 'duo',
                aridad: 2,
                multiplicador: 18,
                categoria: 'inside',
                autorizable: true,
                activa: true,
                canales: ['wallet'],
            },
            {
                id: 'linea',
                grupo: 'linea',
                aridad: 3,
                multiplicador: 12,
                categoria: 'inside',
                autorizable: true,
                activa: true,
                canales: ['wallet'],
            },
            {
                id: 'cuadra',
                grupo: 'cuadra',
                aridad: 4,
                multiplicador: 9,
                categoria: 'inside',
                autorizable: true,
                activa: true,
                canales: ['wallet'],
            },
            {
                id: 'dobleLinea',
                grupo: 'dobleLinea',
                aridad: 6,
                multiplicador: 6,
                categoria: 'inside',
                autorizable: true,
                activa: true,
                canales: ['wallet'],
            },
            // FIJAS inside (botón en grilla / especial). cero acierto directo x36 → grupo 'directo'.
            // FIJAS outside — características.
            {
                id: 'rojos',
                grupo: 'color',
                sectores: [9, 30, 7, 32, 5, 34, 3, 36, 1, 27, 25, 12, 19, 18, 21, 16, 23, 14],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'negros',
                grupo: 'color',
                sectores: [28, 26, 11, 20, 17, 22, 15, 24, 13, 10, 29, 8, 31, 6, 33, 4, 35, 2],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'pares',
                grupo: 'paridad',
                sectores: [28, 26, 30, 20, 32, 22, 34, 24, 36, 10, 12, 8, 18, 6, 16, 4, 14, 2],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'impares',
                grupo: 'paridad',
                sectores: [9, 11, 7, 17, 5, 15, 3, 13, 1, 27, 25, 29, 19, 31, 21, 33, 23, 35],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bajos',
                grupo: 'mitad',
                sectores: [9, 11, 7, 17, 5, 15, 3, 13, 1, 10, 12, 8, 18, 6, 16, 4, 14, 2],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'altos',
                grupo: 'mitad',
                sectores: [28, 26, 30, 20, 32, 22, 34, 24, 36, 27, 25, 29, 19, 31, 21, 33, 23, 35],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'docena1',
                grupo: 'tercios',
                sectores: [9, 11, 7, 5, 3, 1, 10, 12, 8, 6, 4, 2],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'docena2',
                grupo: 'tercios',
                sectores: [20, 17, 22, 15, 24, 13, 19, 18, 21, 16, 23, 14],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'docena3',
                grupo: 'tercios',
                sectores: [28, 26, 30, 32, 34, 36, 27, 25, 29, 31, 33, 35],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'columna1',
                grupo: 'columnas',
                sectores: [28, 7, 22, 34, 13, 1, 10, 25, 19, 31, 16, 4],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'columna2',
                grupo: 'columnas',
                sectores: [26, 11, 20, 32, 17, 5, 29, 8, 23, 35, 14, 2],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'columna3',
                grupo: 'columnas',
                sectores: [9, 30, 15, 3, 24, 36, 27, 12, 18, 6, 21, 33],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueA',
                grupo: 'bloques',
                sectores: [28, 9, 26, 30, 11, 7],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueB',
                grupo: 'bloques',
                sectores: [20, 32, 17, 5, 22, 34],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueC',
                grupo: 'bloques',
                sectores: [15, 3, 24, 36, 13, 1],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueD',
                grupo: 'bloques',
                sectores: [27, 10, 25, 29, 12, 8],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueE',
                grupo: 'bloques',
                sectores: [19, 31, 18, 6, 21, 33],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueF',
                grupo: 'bloques',
                sectores: [16, 4, 23, 35, 14, 2],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'gemelos',
                grupo: 'gemelos',
                sectores: [11, 22, 33],
                multiplicador: 12,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'espejo_12_21',
                grupo: 'espejos',
                sectores: [12, 21],
                multiplicador: 18,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'espejo_13_31',
                grupo: 'espejos',
                sectores: [13, 31],
                multiplicador: 18,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'espejo_23_32',
                grupo: 'espejos',
                sectores: [23, 32],
                multiplicador: 18,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
        ],
        barrasDeStats: [
            { tipo: 'binaria', grupo: 'color', lineas: ['rojos', 'negros'] },
            { tipo: 'binaria', grupo: 'paridad', lineas: ['impares', 'pares'] },
            { tipo: 'binaria', grupo: 'mitad', lineas: ['bajos', 'altos'] },
            { tipo: 'stacked', grupo: 'tercios', lineas: ['docena1', 'docena2', 'docena3'] },
            { tipo: 'stacked', grupo: 'columnas', lineas: ['columna1', 'columna2', 'columna3'] },
            {
                tipo: 'stacked',
                grupo: 'bloques',
                lineas: ['bloqueA', 'bloqueB', 'bloqueC', 'bloqueD', 'bloqueE', 'bloqueF'],
            },
        ],
        mat: {
            columnas: 3,
            botones: [
                { linea: 'docena1', seccion: 'lateral', paleta: 'paleta-6', tipografia: 'tercio' },
                { linea: 'docena2', seccion: 'lateral', paleta: 'paleta-8', tipografia: 'tercio' },
                { linea: 'docena3', seccion: 'lateral', paleta: 'paleta-2', tipografia: 'tercio' },
                { linea: 'columna1', seccion: 'inferior', paleta: 'paleta-9', tipografia: 'columna' },
                { linea: 'columna2', seccion: 'inferior', paleta: 'paleta-10', tipografia: 'columna' },
                { linea: 'columna3', seccion: 'inferior', paleta: 'paleta-11', tipografia: 'columna' },
                { linea: 'rojos', seccion: 'chance', paleta: 'paleta-0', tipografia: 'enfasis' },
                { linea: 'negros', seccion: 'chance', paleta: 'paleta-1', tipografia: 'enfasis' },
                { linea: 'pares', seccion: 'chance', paleta: 'paleta-9', tipografia: 'chance' },
                { linea: 'impares', seccion: 'chance', paleta: 'paleta-12', tipografia: 'chance' },
                { linea: 'bajos', seccion: 'chance', paleta: 'paleta-7', tipografia: 'chance' },
                { linea: 'altos', seccion: 'chance', paleta: 'paleta-5', tipografia: 'chance' },
                { linea: 'bloqueA', seccion: 'special', paleta: 'paleta-4', tipografia: 'especial' },
                { linea: 'bloqueB', seccion: 'special', paleta: 'paleta-3', tipografia: 'especial' },
                { linea: 'bloqueC', seccion: 'special', paleta: 'paleta-4', tipografia: 'especial' },
                { linea: 'bloqueD', seccion: 'special', paleta: 'paleta-3', tipografia: 'especial' },
                { linea: 'bloqueE', seccion: 'special', paleta: 'paleta-4', tipografia: 'especial' },
                { linea: 'bloqueF', seccion: 'special', paleta: 'paleta-3', tipografia: 'especial' },
                { linea: 'gemelos', seccion: 'special', paleta: 'paleta-8', tipografia: 'especial' },
                {
                    linea: 'espejo_12_21',
                    seccion: 'special',
                    paleta: 'paleta-5',
                    tipografia: 'especial',
                    tituloI18nKey: 'lineas.espejos',
                },
                {
                    linea: 'espejo_13_31',
                    seccion: 'special',
                    paleta: 'paleta-10',
                    tipografia: 'especial',
                    tituloI18nKey: 'lineas.espejos',
                },
                {
                    linea: 'espejo_23_32',
                    seccion: 'special',
                    paleta: 'paleta-11',
                    tipografia: 'especial',
                    tituloI18nKey: 'lineas.espejos',
                },
            ],
        },
        geometria: {
            radioInterior: 0.35,
            radioMedio: 0.6,
            radioExterior: 0.98,
            alturaDomo: 0.09, // casquete SUAVE, apenas más alto que el relieve central
            // El tramo del domo (r=0 hasta radioInterior) NO se declara acá — lo
            // calcula resolverPuntosDePerfil() desde alturaDomo (geometría del
            // casquete esférico, empalme garantizado por código, no por un z a mano).
            // El primer punto de este array es el primero DESPUÉS del domo.
            perfilRelieve: [
                { r: 0.475, z: -0.05 },
                { r: 'radioMedio', z: 0 },
                { r: 'radioExterior', z: 0.055 },
                { r: 1, z: 0 },
            ],
        },
    },

    triple_zero: {
        id: 'triple_zero',
        fontFamily: 'RouletteNumbers, Arial, sans-serif',
        sectores: [
            {
                valor: 0,
                bot: 37,
                top: 'LOTO',
                grad: null,
                peso: 1,
                excluidoDeHotCold: true,
                paleta: 'paleta-2',
            },
            { valor: 32, bot: 32, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 15, bot: 15, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 19, bot: 19, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 4, bot: 4, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 21, bot: 21, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 2, bot: 2, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 25, bot: 25, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 17, bot: 17, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 34, bot: 34, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 6, bot: 6, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 27, bot: 27, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 13, bot: 13, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            {
                valor: 37,
                bot: 38,
                top: 'LOTO',
                grad: null,
                peso: 1,
                excluidoDeHotCold: true,
                paleta: 'paleta-2',
            },
            { valor: 36, bot: 36, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 11, bot: 11, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 30, bot: 30, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 8, bot: 8, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 23, bot: 23, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 10, bot: 10, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 5, bot: 5, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 24, bot: 24, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 16, bot: 16, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 33, bot: 33, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 1, bot: 1, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 20, bot: 20, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            {
                valor: 38,
                bot: 39,
                top: 'LOTO',
                grad: null,
                peso: 1,
                excluidoDeHotCold: true,
                paleta: 'paleta-2',
            },
            { valor: 14, bot: 14, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 31, bot: 31, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 9, bot: 9, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 22, bot: 22, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 18, bot: 18, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 29, bot: 29, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 7, bot: 7, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 28, bot: 28, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 12, bot: 12, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 35, bot: 35, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 3, bot: 3, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 26, bot: 26, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
        ],
        apuestas: [
            // GEOMÉTRICAS (canal wallet; el jugador las arma tocando la grilla 3×12).
            {
                id: 'aciertoDirecto',
                grupo: 'directo',
                aridad: 1,
                multiplicador: 36,
                categoria: 'inside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'duo',
                grupo: 'duo',
                aridad: 2,
                multiplicador: 18,
                categoria: 'inside',
                autorizable: true,
                activa: true,
                canales: ['wallet'],
            },
            {
                id: 'linea',
                grupo: 'linea',
                aridad: 3,
                multiplicador: 12,
                categoria: 'inside',
                autorizable: true,
                activa: true,
                canales: ['wallet'],
            },
            {
                id: 'cuadra',
                grupo: 'cuadra',
                aridad: 4,
                multiplicador: 9,
                categoria: 'inside',
                autorizable: true,
                activa: true,
                canales: ['wallet'],
            },
            {
                id: 'dobleLinea',
                grupo: 'dobleLinea',
                aridad: 6,
                multiplicador: 6,
                categoria: 'inside',
                autorizable: true,
                activa: true,
                canales: ['wallet'],
            },
            // FIJAS outside — características.
            {
                id: 'rojos',
                grupo: 'color',
                sectores: [32, 19, 21, 25, 34, 27, 36, 30, 23, 5, 16, 1, 14, 9, 18, 7, 12, 3],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'negros',
                grupo: 'color',
                sectores: [15, 4, 2, 17, 6, 13, 11, 8, 10, 24, 33, 20, 31, 22, 29, 28, 35, 26],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'pares',
                grupo: 'paridad',
                sectores: [32, 4, 2, 34, 6, 36, 30, 8, 10, 24, 16, 20, 14, 22, 18, 28, 12, 26],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'impares',
                grupo: 'paridad',
                sectores: [15, 19, 21, 25, 17, 27, 13, 11, 23, 5, 33, 1, 31, 9, 29, 7, 35, 3],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bajos',
                grupo: 'mitad',
                sectores: [15, 4, 2, 17, 6, 13, 11, 8, 10, 5, 16, 1, 14, 9, 18, 7, 12, 3],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'altos',
                grupo: 'mitad',
                sectores: [32, 19, 21, 25, 34, 27, 36, 30, 23, 24, 33, 20, 31, 22, 29, 28, 35, 26],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'docena1',
                grupo: 'tercios',
                sectores: [4, 2, 6, 11, 8, 10, 5, 1, 9, 7, 12, 3],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'docena2',
                grupo: 'tercios',
                sectores: [15, 19, 21, 17, 13, 23, 24, 16, 20, 14, 22, 18],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'docena3',
                grupo: 'tercios',
                sectores: [32, 25, 34, 27, 36, 30, 33, 31, 29, 28, 35, 26],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'columna1',
                grupo: 'columnas',
                sectores: [19, 4, 25, 34, 13, 10, 16, 1, 31, 22, 7, 28],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'columna2',
                grupo: 'columnas',
                sectores: [32, 2, 17, 11, 8, 23, 5, 20, 14, 29, 35, 26],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'columna3',
                grupo: 'columnas',
                sectores: [15, 21, 6, 27, 36, 30, 24, 33, 9, 18, 12, 3],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueA',
                grupo: 'bloques',
                sectores: [32, 15, 19, 4, 21, 2],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueB',
                grupo: 'bloques',
                sectores: [25, 17, 34, 6, 27, 13],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueC',
                grupo: 'bloques',
                sectores: [36, 11, 30, 8, 23, 10],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueD',
                grupo: 'bloques',
                sectores: [5, 24, 16, 33, 1, 20],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueE',
                grupo: 'bloques',
                sectores: [14, 31, 9, 22, 18, 29],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueF',
                grupo: 'bloques',
                sectores: [7, 28, 12, 35, 3, 26],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'gemelos',
                grupo: 'gemelos',
                sectores: [11, 22, 33],
                multiplicador: 12,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'espejo_12_21',
                grupo: 'espejos',
                sectores: [12, 21],
                multiplicador: 18,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'espejo_13_31',
                grupo: 'espejos',
                sectores: [13, 31],
                multiplicador: 18,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'espejo_23_32',
                grupo: 'espejos',
                sectores: [23, 32],
                multiplicador: 18,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
        ],
        barrasDeStats: [
            { tipo: 'binaria', grupo: 'color', lineas: ['rojos', 'negros'] },
            { tipo: 'binaria', grupo: 'paridad', lineas: ['impares', 'pares'] },
            { tipo: 'binaria', grupo: 'mitad', lineas: ['bajos', 'altos'] },
            { tipo: 'stacked', grupo: 'tercios', lineas: ['docena1', 'docena2', 'docena3'] },
            { tipo: 'stacked', grupo: 'columnas', lineas: ['columna1', 'columna2', 'columna3'] },
            {
                tipo: 'stacked',
                grupo: 'bloques',
                lineas: ['bloqueA', 'bloqueB', 'bloqueC', 'bloqueD', 'bloqueE', 'bloqueF'],
            },
        ],
        mat: {
            columnas: 3,
            botones: [
                { linea: 'docena1', seccion: 'lateral', paleta: 'paleta-6', tipografia: 'tercio' },
                { linea: 'docena2', seccion: 'lateral', paleta: 'paleta-8', tipografia: 'tercio' },
                { linea: 'docena3', seccion: 'lateral', paleta: 'paleta-2', tipografia: 'tercio' },
                { linea: 'columna1', seccion: 'inferior', paleta: 'paleta-9', tipografia: 'columna' },
                { linea: 'columna2', seccion: 'inferior', paleta: 'paleta-10', tipografia: 'columna' },
                { linea: 'columna3', seccion: 'inferior', paleta: 'paleta-11', tipografia: 'columna' },
                { linea: 'rojos', seccion: 'chance', paleta: 'paleta-0', tipografia: 'enfasis' },
                { linea: 'negros', seccion: 'chance', paleta: 'paleta-1', tipografia: 'enfasis' },
                { linea: 'pares', seccion: 'chance', paleta: 'paleta-9', tipografia: 'chance' },
                { linea: 'impares', seccion: 'chance', paleta: 'paleta-12', tipografia: 'chance' },
                { linea: 'bajos', seccion: 'chance', paleta: 'paleta-7', tipografia: 'chance' },
                { linea: 'altos', seccion: 'chance', paleta: 'paleta-5', tipografia: 'chance' },
                { linea: 'bloqueA', seccion: 'special', paleta: 'paleta-4', tipografia: 'especial' },
                { linea: 'bloqueB', seccion: 'special', paleta: 'paleta-3', tipografia: 'especial' },
                { linea: 'bloqueC', seccion: 'special', paleta: 'paleta-4', tipografia: 'especial' },
                { linea: 'bloqueD', seccion: 'special', paleta: 'paleta-3', tipografia: 'especial' },
                { linea: 'bloqueE', seccion: 'special', paleta: 'paleta-4', tipografia: 'especial' },
                { linea: 'bloqueF', seccion: 'special', paleta: 'paleta-3', tipografia: 'especial' },
                { linea: 'gemelos', seccion: 'special', paleta: 'paleta-8', tipografia: 'especial' },
                {
                    linea: 'espejo_12_21',
                    seccion: 'special',
                    paleta: 'paleta-5',
                    tipografia: 'especial',
                    tituloI18nKey: 'lineas.espejos',
                },
                {
                    linea: 'espejo_13_31',
                    seccion: 'special',
                    paleta: 'paleta-10',
                    tipografia: 'especial',
                    tituloI18nKey: 'lineas.espejos',
                },
                {
                    linea: 'espejo_23_32',
                    seccion: 'special',
                    paleta: 'paleta-11',
                    tipografia: 'especial',
                    tituloI18nKey: 'lineas.espejos',
                },
            ],
        },
        geometria: {
            radioInterior: 0.35,
            radioMedio: 0.6,
            radioExterior: 0.98,
            alturaDomo: 0.09, // casquete SUAVE, apenas más alto que el relieve central
            // El tramo del domo (r=0 hasta radioInterior) NO se declara acá — lo
            // calcula resolverPuntosDePerfil() desde alturaDomo (geometría del
            // casquete esférico, empalme garantizado por código, no por un z a mano).
            // El primer punto de este array es el primero DESPUÉS del domo.
            perfilRelieve: [
                { r: 0.475, z: -0.05 },
                { r: 'radioMedio', z: 0 },
                { r: 'radioExterior', z: 0.055 },
                { r: 1, z: 0 },
            ],
        },
    },

    mini: {
        id: 'mini',
        fontFamily: 'RouletteNumbers, Arial, sans-serif',
        sectores: [
            {
                valor: 0,
                bot: '12+1',
                top: 'LOTO',
                grad: null,
                peso: 1,
                excluidoDeHotCold: true,
                paleta: 'paleta-2',
            },
            { valor: 8, bot: 8, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 3, bot: 3, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 12, bot: 12, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 6, bot: 6, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 1, bot: 1, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 10, bot: 10, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 4, bot: 4, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 2, bot: 2, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 9, bot: 9, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 11, bot: 11, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 5, bot: 5, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 7, bot: 7, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
        ],
        apuestas: [
            // GEOMÉTRICAS (canal wallet; el jugador las arma tocando la grilla 2×6).
            {
                id: 'aciertoDirecto',
                grupo: 'directo',
                aridad: 1,
                multiplicador: 12,
                categoria: 'inside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'duo',
                grupo: 'duo',
                aridad: 2,
                multiplicador: 6,
                categoria: 'inside',
                autorizable: true,
                activa: true,
                canales: ['wallet'],
            },
            {
                id: 'linea',
                grupo: 'linea',
                aridad: 3,
                multiplicador: 4,
                categoria: 'inside',
                autorizable: true,
                activa: false,
                canales: ['wallet'],
            },
            {
                id: 'cuadra',
                grupo: 'cuadra',
                aridad: 4,
                multiplicador: 3,
                categoria: 'inside',
                autorizable: true,
                activa: true,
                canales: ['wallet'],
            },
            {
                id: 'dobleLinea',
                grupo: 'dobleLinea',
                aridad: 6,
                multiplicador: 2,
                categoria: 'inside',
                autorizable: true,
                activa: false,
                canales: ['wallet'],
            },
            // FIJAS inside del cero. cero acierto directo x12 → grupo 'directo'.
            // FIJAS outside — características.
            {
                id: 'rojos',
                grupo: 'color',
                sectores: [8, 12, 1, 4, 9, 5],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'negros',
                grupo: 'color',
                sectores: [3, 6, 10, 2, 11, 7],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'pares',
                grupo: 'paridad',
                sectores: [8, 12, 6, 10, 4, 2],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'impares',
                grupo: 'paridad',
                sectores: [3, 1, 9, 11, 5, 7],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bajos',
                grupo: 'mitad',
                sectores: [3, 6, 1, 4, 2, 5],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'altos',
                grupo: 'mitad',
                sectores: [8, 12, 10, 9, 11, 7],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'docena1',
                grupo: 'tercios',
                sectores: [3, 1, 4, 2],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'docena2',
                grupo: 'tercios',
                sectores: [8, 6, 5, 7],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'docena3',
                grupo: 'tercios',
                sectores: [12, 10, 9, 11],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'columna1',
                grupo: 'columnas',
                sectores: [3, 1, 9, 11, 5, 7],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'columna2',
                grupo: 'columnas',
                sectores: [8, 12, 6, 10, 4, 2],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueA',
                grupo: 'bloques',
                sectores: [8, 3, 12],
                multiplicador: 4,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueB',
                grupo: 'bloques',
                sectores: [6, 1, 10],
                multiplicador: 4,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueC',
                grupo: 'bloques',
                sectores: [4, 2, 9],
                multiplicador: 4,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueD',
                grupo: 'bloques',
                sectores: [11, 5, 7],
                multiplicador: 4,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
        ],
        barrasDeStats: [
            { tipo: 'binaria', grupo: 'color', lineas: ['rojos', 'negros'] },
            { tipo: 'binaria', grupo: 'paridad', lineas: ['impares', 'pares'] },
            { tipo: 'binaria', grupo: 'mitad', lineas: ['bajos', 'altos'] },
            { tipo: 'stacked', grupo: 'tercios', lineas: ['docena1', 'docena2', 'docena3'] },
            { tipo: 'stacked', grupo: 'columnas', lineas: ['columna1', 'columna2'] },
            { tipo: 'stacked', grupo: 'bloques', lineas: ['bloqueA', 'bloqueB', 'bloqueC', 'bloqueD'] },
        ],
        mat: {
            columnas: 2,
            botones: [
                { linea: 'docena1', seccion: 'lateral', paleta: 'paleta-6', tipografia: 'tercio' },
                { linea: 'docena2', seccion: 'lateral', paleta: 'paleta-8', tipografia: 'tercio' },
                { linea: 'docena3', seccion: 'lateral', paleta: 'paleta-2', tipografia: 'tercio' },
                { linea: 'columna1', seccion: 'inferior', paleta: 'paleta-9', tipografia: 'columna' },
                { linea: 'columna2', seccion: 'inferior', paleta: 'paleta-10', tipografia: 'columna' },
                { linea: 'rojos', seccion: 'chance', paleta: 'paleta-0', tipografia: 'enfasis' },
                { linea: 'negros', seccion: 'chance', paleta: 'paleta-1', tipografia: 'enfasis' },
                { linea: 'pares', seccion: 'chance', paleta: 'paleta-9', tipografia: 'chance' },
                { linea: 'impares', seccion: 'chance', paleta: 'paleta-12', tipografia: 'chance' },
                { linea: 'bajos', seccion: 'chance', paleta: 'paleta-7', tipografia: 'chance' },
                { linea: 'altos', seccion: 'chance', paleta: 'paleta-5', tipografia: 'chance' },
                { linea: 'bloqueA', seccion: 'special', paleta: 'paleta-4', tipografia: 'especial' },
                { linea: 'bloqueB', seccion: 'special', paleta: 'paleta-3', tipografia: 'especial' },
                { linea: 'bloqueC', seccion: 'special', paleta: 'paleta-4', tipografia: 'especial' },
                { linea: 'bloqueD', seccion: 'special', paleta: 'paleta-3', tipografia: 'especial' },
            ],
        },
        // El cero muestra "12+1" en el centro: activar el auto-encogido (mecanismo
        // _fontQueEntra de center-display) para que entre en el hub aunque el wheel
        // sea chico (caja web). Aditivo: si ya entra (wheel grande, TV) no hace nada.
        ajustarCentroAlCirculo: true,
        geometria: {
            radioInterior: 0.35,
            radioMedio: 0.6,
            radioExterior: 0.98,
            alturaDomo: 0.09, // casquete SUAVE, apenas más alto que el relieve central
            // El tramo del domo (r=0 hasta radioInterior) NO se declara acá — lo
            // calcula resolverPuntosDePerfil() desde alturaDomo (geometría del
            // casquete esférico, empalme garantizado por código, no por un z a mano).
            // El primer punto de este array es el primero DESPUÉS del domo.
            perfilRelieve: [
                { r: 0.475, z: -0.05 },
                { r: 'radioMedio', z: 0 },
                { r: 'radioExterior', z: 0.055 },
                { r: 1, z: 0 },
            ],
        },
    },

    mini18: {
        id: 'mini18',
        fontFamily: 'RouletteNumbers, Arial, sans-serif',
        sectores: [
            {
                valor: 0,
                bot: '18+1',
                top: 'LOTO',
                grad: null,
                peso: 1,
                excluidoDeHotCold: true,
                paleta: 'paleta-2',
            },
            { valor: 1, bot: 1, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 7, bot: 7, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 13, bot: 13, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 2, bot: 2, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 8, bot: 8, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 14, bot: 14, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 3, bot: 3, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 9, bot: 9, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 15, bot: 15, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 4, bot: 4, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 10, bot: 10, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 16, bot: 16, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 5, bot: 5, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 11, bot: 11, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 17, bot: 17, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 6, bot: 6, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 12, bot: 12, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 18, bot: 18, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
        ],
        apuestas: [
            // GEOMÉTRICAS (canal wallet; el jugador las arma tocando la grilla 3×6).
            {
                id: 'aciertoDirecto',
                grupo: 'directo',
                aridad: 1,
                multiplicador: 18,
                categoria: 'inside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'duo',
                grupo: 'duo',
                aridad: 2,
                multiplicador: 9,
                categoria: 'inside',
                autorizable: true,
                activa: true,
                canales: ['wallet'],
            },
            {
                id: 'linea',
                grupo: 'linea',
                aridad: 3,
                multiplicador: 6,
                categoria: 'inside',
                autorizable: true,
                activa: true,
                canales: ['wallet'],
            },
            {
                id: 'cuadra',
                grupo: 'cuadra',
                aridad: 4,
                multiplicador: 4.5,
                categoria: 'inside',
                autorizable: true,
                activa: false,
                canales: ['wallet'],
            },
            {
                id: 'dobleLinea',
                grupo: 'dobleLinea',
                aridad: 6,
                multiplicador: 3,
                categoria: 'inside',
                autorizable: true,
                activa: true,
                canales: ['wallet'],
            },
            // FIJAS inside del cero. cero acierto directo x18 → grupo 'directo'.
            // FIJAS outside — características.
            {
                id: 'rojos',
                grupo: 'color',
                sectores: [1, 13, 8, 3, 15, 10, 5, 17, 12],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'negros',
                grupo: 'color',
                sectores: [7, 2, 14, 9, 4, 16, 11, 6, 18],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'pares',
                grupo: 'paridad',
                sectores: [2, 8, 14, 4, 10, 16, 6, 12, 18],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'impares',
                grupo: 'paridad',
                sectores: [1, 7, 13, 3, 9, 15, 5, 11, 17],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bajos',
                grupo: 'mitad',
                sectores: [1, 7, 2, 8, 3, 9, 4, 5, 6],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'altos',
                grupo: 'mitad',
                sectores: [13, 14, 15, 10, 16, 11, 17, 12, 18],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'docena1',
                grupo: 'tercios',
                sectores: [1, 2, 3, 4, 5, 6],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'docena2',
                grupo: 'tercios',
                sectores: [7, 8, 9, 10, 11, 12],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'docena3',
                grupo: 'tercios',
                sectores: [13, 14, 15, 16, 17, 18],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'columna1',
                grupo: 'columnas',
                sectores: [1, 7, 13, 4, 10, 16],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'columna2',
                grupo: 'columnas',
                sectores: [2, 8, 14, 5, 11, 17],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'columna3',
                grupo: 'columnas',
                sectores: [3, 9, 15, 6, 12, 18],
                multiplicador: 3,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueA',
                grupo: 'bloques',
                sectores: [1, 7, 13],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueB',
                grupo: 'bloques',
                sectores: [2, 8, 14],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueC',
                grupo: 'bloques',
                sectores: [3, 9, 15],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueD',
                grupo: 'bloques',
                sectores: [4, 10, 16],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueE',
                grupo: 'bloques',
                sectores: [5, 11, 17],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bloqueF',
                grupo: 'bloques',
                sectores: [6, 12, 18],
                multiplicador: 6,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
        ],
        barrasDeStats: [
            { tipo: 'binaria', grupo: 'color', lineas: ['rojos', 'negros'] },
            { tipo: 'binaria', grupo: 'paridad', lineas: ['impares', 'pares'] },
            { tipo: 'binaria', grupo: 'mitad', lineas: ['bajos', 'altos'] },
            { tipo: 'stacked', grupo: 'tercios', lineas: ['docena1', 'docena2', 'docena3'] },
            { tipo: 'stacked', grupo: 'columnas', lineas: ['columna1', 'columna2', 'columna3'] },
            {
                tipo: 'stacked',
                grupo: 'bloques',
                lineas: ['bloqueA', 'bloqueB', 'bloqueC', 'bloqueD', 'bloqueE', 'bloqueF'],
            },
        ],
        mat: {
            columnas: 3,
            botones: [
                { linea: 'docena1', seccion: 'lateral', paleta: 'paleta-6', tipografia: 'tercio' },
                { linea: 'docena2', seccion: 'lateral', paleta: 'paleta-8', tipografia: 'tercio' },
                { linea: 'docena3', seccion: 'lateral', paleta: 'paleta-2', tipografia: 'tercio' },
                { linea: 'columna1', seccion: 'inferior', paleta: 'paleta-9', tipografia: 'columna' },
                { linea: 'columna2', seccion: 'inferior', paleta: 'paleta-10', tipografia: 'columna' },
                { linea: 'columna3', seccion: 'inferior', paleta: 'paleta-11', tipografia: 'columna' },
                { linea: 'rojos', seccion: 'chance', paleta: 'paleta-0', tipografia: 'enfasis' },
                { linea: 'negros', seccion: 'chance', paleta: 'paleta-1', tipografia: 'enfasis' },
                { linea: 'pares', seccion: 'chance', paleta: 'paleta-9', tipografia: 'chance' },
                { linea: 'impares', seccion: 'chance', paleta: 'paleta-12', tipografia: 'chance' },
                { linea: 'bajos', seccion: 'chance', paleta: 'paleta-7', tipografia: 'chance' },
                { linea: 'altos', seccion: 'chance', paleta: 'paleta-5', tipografia: 'chance' },
                { linea: 'bloqueA', seccion: 'special', paleta: 'paleta-4', tipografia: 'especial' },
                { linea: 'bloqueB', seccion: 'special', paleta: 'paleta-3', tipografia: 'especial' },
                { linea: 'bloqueC', seccion: 'special', paleta: 'paleta-4', tipografia: 'especial' },
                { linea: 'bloqueD', seccion: 'special', paleta: 'paleta-3', tipografia: 'especial' },
                { linea: 'bloqueE', seccion: 'special', paleta: 'paleta-4', tipografia: 'especial' },
                { linea: 'bloqueF', seccion: 'special', paleta: 'paleta-3', tipografia: 'especial' },
            ],
        },
        geometria: {
            radioInterior: 0.35,
            radioMedio: 0.6,
            radioExterior: 0.98,
            alturaDomo: 0.09, // casquete SUAVE, apenas más alto que el relieve central
            // El tramo del domo (r=0 hasta radioInterior) NO se declara acá — lo
            // calcula resolverPuntosDePerfil() desde alturaDomo (geometría del
            // casquete esférico, empalme garantizado por código, no por un z a mano).
            // El primer punto de este array es el primero DESPUÉS del domo.
            perfilRelieve: [
                { r: 0.475, z: -0.05 },
                { r: 'radioMedio', z: 0 },
                { r: 'radioExterior', z: 0.055 },
                { r: 1, z: 0 },
            ],
        },
    },

    rueda10: {
        id: 'rueda10',
        fontFamily: 'RouletteNumbers, Arial, sans-serif',
        sectores: [
            {
                valor: 0,
                bot: '10+1',
                top: 'LOTO',
                grad: null,
                peso: 1,
                excluidoDeHotCold: true,
                paleta: 'paleta-2',
            },
            { valor: 1, bot: 1, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 6, bot: 6, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 3, bot: 3, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 8, bot: 8, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 5, bot: 5, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 10, bot: 10, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 7, bot: 7, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 2, bot: 2, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 9, bot: 9, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 4, bot: 4, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
        ],
        apuestas: [
            // GEOMÉTRICAS (canal wallet; el jugador las arma tocando la grilla 2×5).
            {
                id: 'aciertoDirecto',
                grupo: 'directo',
                aridad: 1,
                multiplicador: 10,
                categoria: 'inside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'duo',
                grupo: 'duo',
                aridad: 2,
                multiplicador: 5,
                categoria: 'inside',
                autorizable: true,
                activa: true,
                canales: ['wallet'],
            },
            // FIJAS inside del cero. cero acierto directo x10 → grupo 'directo'.
            // FIJAS outside — características.
            {
                id: 'rojos',
                grupo: 'color',
                sectores: [1, 3, 5, 7, 9],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'negros',
                grupo: 'color',
                sectores: [6, 8, 10, 2, 4],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'pares',
                grupo: 'paridad',
                sectores: [6, 8, 10, 2, 4],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'impares',
                grupo: 'paridad',
                sectores: [1, 3, 5, 7, 9],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bajos',
                grupo: 'mitad',
                sectores: [1, 3, 5, 2, 4],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'altos',
                grupo: 'mitad',
                sectores: [6, 8, 10, 7, 9],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'columna1',
                grupo: 'columnas',
                sectores: [1, 3, 5, 7, 9],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'columna2',
                grupo: 'columnas',
                sectores: [6, 8, 10, 2, 4],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
        ],
        barrasDeStats: [
            { tipo: 'binaria', grupo: 'color', lineas: ['rojos', 'negros'] },
            { tipo: 'binaria', grupo: 'paridad', lineas: ['impares', 'pares'] },
            { tipo: 'binaria', grupo: 'mitad', lineas: ['bajos', 'altos'] },
            { tipo: 'stacked', grupo: 'columnas', lineas: ['columna1', 'columna2'] },
        ],
        mat: {
            columnas: 2,
            botones: [
                { linea: 'columna1', seccion: 'inferior', paleta: 'paleta-9', tipografia: 'columna' },
                { linea: 'columna2', seccion: 'inferior', paleta: 'paleta-10', tipografia: 'columna' },
                { linea: 'rojos', seccion: 'chance', paleta: 'paleta-0', tipografia: 'enfasis' },
                { linea: 'negros', seccion: 'chance', paleta: 'paleta-1', tipografia: 'enfasis' },
                { linea: 'pares', seccion: 'chance', paleta: 'paleta-9', tipografia: 'chance' },
                { linea: 'impares', seccion: 'chance', paleta: 'paleta-12', tipografia: 'chance' },
                { linea: 'bajos', seccion: 'chance', paleta: 'paleta-7', tipografia: 'chance' },
                { linea: 'altos', seccion: 'chance', paleta: 'paleta-5', tipografia: 'chance' },
            ],
            // El LOTO no colinda con ninguna directa específica del mat —
            // el caballo entre LOTO y un número no representa nada real.
            bordesApostables: { duoEntreSuperiorYDirectaInterior: false },
        },
        geometria: {
            radioInterior: 0.4,
            radioMedio: 0.4,
            radioExterior: 0.98,
            anchoBordeInterior: 18,
            alturaDomo: 0.09, // casquete SUAVE, apenas más alto que el relieve central
            // El tramo del domo (r=0 hasta radioInterior) NO se declara acá — lo
            // calcula resolverPuntosDePerfil() desde alturaDomo. Sin anillo de bloques
            // (radioInterior===radioMedio): del domo sube derecho al borde, sin
            // depresión — coherente con que esta receta no tiene bloques A-F.
            perfilRelieve: [
                { r: 'radioExterior', z: 0.055 },
                { r: 1, z: 0 },
            ],
        },
        // LIGHTNING — banco de pruebas del SIMULADOR (--lightning-on forzado). Esta rueda NO se
        // activa NUNCA (decisión dueño 2026-07-11: rueda10 no se toca — la activación real va en
        // recetas dedicadas como mega3000/reddoor, cada una con su tabla ya recortada). El bloque
        // queda para los A/B del gate por fondo, que se corrieron acá (lightning-datos-duros §5).
        lightning: {
            // SIEMPRE false: validarConfigLightning exigiría pleno === tabla (x10) al activar.
            activo: false,
            afortunadosPorRonda: { min: 0, max: 3, pesos: [400, 400, 150, 50] },
            pleno: 5,
            tiers: [
                { mult: 20, peso: 100 },
                { mult: 50, peso: 40 },
                { mult: 100, peso: 20 },
                { mult: 500, peso: 3 },
                { mult: 1000, peso: 1 },
            ],
            rtpObjetivo: 0.85,
            capPorApuesta: 5000000, // cortafuegos: tope 50.000 por apuesta (ÚLTIMA red, no la solución)
            // COLOCACIÓN sesgada: el precook pone los afortunados donde hay MENOS pleno apostado
            // (premio grande barato si sale). SESGO ACOTADO (no imán fijo): `base` es el piso uniforme
            // que impide que un sector quede en ~0%/~100% y sea explotable; `factor` gradúa el sesgo.
            //   peso[i] = base + factor / (1 + plenoApostado[i])
            // Con factor 0 (o sin este bloque) → colocación uniforme, como el casino.
            // OJO: sesgar reduce el payout esperado del lightning → el `pleno` recortado asume uniforme;
            // recalibrar si se sube el factor (ver lightning-modelo-canonico.md).
            sesgoColocacion: { base: 1, factor: 3 },
            // CONTROL PREVENTIVO vía el fondo común: en fondo flaco el resolver EVITA el sector
            // afortunado con esta probabilidad (por ronda), en vez de dejarlo salir y capar el premio.
            // El jugador que gana cobra COMPLETO (sin cap); si el fondo está flaco, el premio no sale
            // esa ronda (indistinguible de perder). Fondo sano (equilibrio/soltar) → sale completo.
            // Agresividad POR RECETA: cada rueda ajusta cuánto protege el fondo vs cuánto expone el x3000.
            evitarAfortunadoEnPanico: 0.9, // en PÁNICO evita el afortunado el 90% de las rondas
            evitarAfortunadoEnProteccion: 0.6, // en PROTECCIÓN, el 60%
            bonus: {
                tipo: 'multiplicador',
                nombre: 'Lightning',
                descripcionFront: 'Sectores afortunados brillan con su multiplicador.',
            },
        },
    },

    rueda10_american: {
        id: 'rueda10_american',
        fontFamily: 'RouletteNumbers, Arial, sans-serif',
        sectores: [
            {
                valor: 0,
                bot: 'X5',
                top: 'LOTO',
                grad: null,
                peso: 1,
                excluidoDeHotCold: true,
                paleta: 'paleta-2',
            },
            { valor: 1, bot: 1, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 6, bot: 6, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 3, bot: 3, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 8, bot: 8, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 5, bot: 5, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            {
                valor: 11,
                bot: 'X5',
                top: 'LOTO',
                grad: null,
                peso: 1,
                excluidoDeHotCold: true,
                paleta: 'paleta-2',
            },
            { valor: 10, bot: 10, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 7, bot: 7, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 2, bot: 2, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
            { valor: 9, bot: 9, top: null, grad: null, peso: 1, paleta: 'paleta-0' },
            { valor: 4, bot: 4, top: null, grad: null, peso: 1, paleta: 'paleta-1' },
        ],
        apuestas: [
            // GEOMÉTRICAS (el jugador las arma tocando; canal wallet). aciertoDirecto
            // = acertar el sector exacto; duo = dos adyacentes. (rueda de 2 columnas:
            // sin linea/cuadra/dobleLinea — no hay grilla suficiente.)
            {
                id: 'aciertoDirecto',
                grupo: 'directo',
                aridad: 1,
                multiplicador: 10,
                categoria: 'inside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'duo',
                grupo: 'duo',
                aridad: 2,
                multiplicador: 5,
                categoria: 'inside',
                autorizable: true,
                activa: true,
                canales: ['wallet'],
            },
            // FIJA — el LOTO cubre los dos sectores X5 (valores 0 y 11), paga x5.
            // Fila propia "LOTO" en la tabla (grupo:'loto'), separada del acierto directo.
            {
                id: 'loto',
                grupo: 'loto',
                sectores: [0, 11],
                multiplicador: 5,
                categoria: 'inside',
                autorizable: true,
                activa: true,
            },
            // FIJAS outside — características (color, paridad, mitad).
            {
                id: 'rojos',
                grupo: 'color',
                sectores: [1, 3, 5, 7, 9],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'negros',
                grupo: 'color',
                sectores: [6, 8, 10, 2, 4],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'pares',
                grupo: 'paridad',
                sectores: [6, 8, 10, 2, 4],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'impares',
                grupo: 'paridad',
                sectores: [1, 3, 5, 7, 9],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'bajos',
                grupo: 'mitad',
                sectores: [1, 3, 5, 2, 4],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'altos',
                grupo: 'mitad',
                sectores: [6, 8, 10, 7, 9],
                multiplicador: 2,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
        ],
        barrasDeStats: [
            { tipo: 'binaria', grupo: 'color', lineas: ['rojos', 'negros'] },
            { tipo: 'binaria', grupo: 'paridad', lineas: ['impares', 'pares'] },
            { tipo: 'binaria', grupo: 'mitad', lineas: ['bajos', 'altos'] },
        ],
        mat: {
            columnas: 2,
            botones: [
                { linea: 'loto', seccion: 'superior', spanColumnas: 2, paleta: 'paleta-2', tipografia: 'loto' },
                { linea: 'rojos', seccion: 'chance', paleta: 'paleta-0', tipografia: 'enfasis' },
                { linea: 'negros', seccion: 'chance', paleta: 'paleta-1', tipografia: 'enfasis' },
                { linea: 'pares', seccion: 'chance', paleta: 'paleta-9', tipografia: 'chance' },
                { linea: 'impares', seccion: 'chance', paleta: 'paleta-12', tipografia: 'chance' },
                { linea: 'bajos', seccion: 'chance', paleta: 'paleta-7', tipografia: 'chance' },
                { linea: 'altos', seccion: 'chance', paleta: 'paleta-5', tipografia: 'chance' },
            ],
            // Los dos LOTOs (sectores 0 y 11) no son adyacentes a ninguna
            // directa específica del mat — el caballo entre el botón LOTO y
            // un número crearía una apuesta sin significado geométrico.
            bordesApostables: { duoEntreSuperiorYDirectaInterior: false },
        },
        geometria: {
            radioInterior: 0.4,
            radioMedio: 0.4,
            radioExterior: 0.98,
            anchoBordeInterior: 18,
            alturaDomo: 0.09, // casquete SUAVE, apenas más alto que el relieve central
            // PRUEBA 3D (2026-07-11, v6 — el domo se veía hundido/tapado porque el
            // MESH del domo se asentaba a una altura FIJA (GROSOR_BASE+0.005) ignorando
            // perfilRelieve; fix real en rueda-3d-objetos.js (geometriaDomo.translate
            // ahora lee alturaCaraSuperior(0)), no en esta receta. Con el domo arreglado,
            // v7 (2026-07-11): el radio REAL donde el motor 2D dibuja el texto de
            // cada número es rMid + (rOut-rMid)*R_NUMBER_POS (wheel-of-fortune.js
            // _radioDelTextoEnSector, R_NUMBER_POS=0.78 en wheel-config.js) — para
            // esta receta (rMid=0.4, rOut=0.98) da r≈0.85. v6 tenía el CANAL
            // exactamente en r=0.85: los números caían literal en el punto más bajo
            // del perfil. v7 puso un PICO puntual en r=0.85 — insuficiente: el glyph
            // tiene ALTURA física en el radio (no es un punto), así que la mitad
            // superior/inferior del número seguía cayendo en la pendiente vecina.
            // v8: meseta ANCHA plana (protege el glyph) pero canal DEMASIADO
            // profundo (z=0.04 contra meseta 0.08 y reborde 0.1 — pozo visible) y
            // la meseta sin ninguna gracia fuera de la zona protegida. v9: la
            // franja plana que protege el texto (0.78-0.9, DERIVADA de
            // R_NUMBER_POS, no movida) se mantiene intacta; el canal ya no es un
            // pozo (0.07, apenas un respiro antes de subir); y se agrega
            // ONDULACIÓN antes/después de esa franja. v10 (pedido explícito): el
            // respiro antes del reborde se acerca 50% más al borde (r=0.95→0.965,
            // 50% de (radioExterior-0.95)); y ANTES del límite interior del texto
            // (r=0.78) se agrega una bajada marcada a un 20% del tramo
            // radioInterior→0.78 (r≈0.48, hacia el centro) que empalma con el
            // ascenso del domo — sube-baja-sube real, no una rampa continua. v11:
            // la zona baja cercana al domo se EXTIENDE 50% más (r=0.48→0.52,
            // 50% más de tramo entre radioInterior=0.4 y 0.48) — la superficie se
            // mantiene baja por más radio antes de empezar a subir hacia el texto.
            // El tramo del domo (r=0 hasta radioInterior) NO se declara acá — lo
            // calcula resolverPuntosDePerfil() desde alturaDomo. Sin afectar el 2D
            // (perfilRelieve lo ignora): solo el playground 3D lo lee.
            perfilRelieve: [
                { r: 0.52, z: 0.015 }, // bajada seria EXTENDIDA — se mantiene baja más radio, empalma hacia el centro
                { r: 0.65, z: 0.06 }, // vuelve a subir desde la bajada, con curva
                { r: 0.78, z: 0.08 }, // arranca la meseta plana — margen real ANTES del texto (0.85)
                { r: 0.9, z: 0.08 }, // meseta plana sigue — margen real DESPUÉS del texto
                { r: 0.965, z: 0.07 }, // respiro antes del reborde — 50% más cerca del borde que v9
                { r: 'radioExterior', z: 0.1 }, // REBORDE alto y definido, el "wow"
                { r: 1, z: 0 }, // canto exterior
            ],
        },
    },

    mundial: {
        id: 'mundial',
        // No se ofrece en el selector del admin (histórico: nunca estuvo en el dropdown).
        // Quitar esta línea la haría seleccionable — sin tocar el front.
        seleccionableEnAdmin: false,
        fontFamily: 'RouletteNumbers, Arial, sans-serif',
        // 16 sectores numerados 1..16; `bot` lleva el pais visible en la rueda
        // y en la celda del mat. Sin cero/loto (no aplica a paises).
        sectores: [
            { valor: 1, bot: 'Argentina', paleta: 'paleta-0', top: null, grad: null, peso: 1 },
            { valor: 2, bot: 'Brasil', paleta: 'paleta-1', top: null, grad: null, peso: 1 },
            { valor: 3, bot: 'Uruguay', paleta: 'paleta-2', top: null, grad: null, peso: 1 },
            { valor: 4, bot: 'México', paleta: 'paleta-3', top: null, grad: null, peso: 1 },
            { valor: 5, bot: 'Alemania', paleta: 'paleta-4', top: null, grad: null, peso: 1 },
            { valor: 6, bot: 'Francia', paleta: 'paleta-5', top: null, grad: null, peso: 1 },
            { valor: 7, bot: 'España', paleta: 'paleta-6', top: null, grad: null, peso: 1 },
            { valor: 8, bot: 'Inglaterra', paleta: 'paleta-7', top: null, grad: null, peso: 1 },
            { valor: 9, bot: 'Italia', paleta: 'paleta-8', top: null, grad: null, peso: 1 },
            { valor: 10, bot: 'Portugal', paleta: 'paleta-9', top: null, grad: null, peso: 1 },
            { valor: 11, bot: 'Países Bajos', paleta: 'paleta-10', top: null, grad: null, peso: 1 },
            { valor: 12, bot: 'Bélgica', paleta: 'paleta-11', top: null, grad: null, peso: 1 },
            { valor: 13, bot: 'Croacia', paleta: 'paleta-0', top: null, grad: null, peso: 1 },
            { valor: 14, bot: 'Estados Unidos', paleta: 'paleta-1', top: null, grad: null, peso: 1 },
            { valor: 15, bot: 'Japón', paleta: 'paleta-2', top: null, grad: null, peso: 1 },
            { valor: 16, bot: 'Corea del Sur', paleta: 'paleta-3', top: null, grad: null, peso: 1 },
        ],
        // Cada pais es UNA apuesta independiente: cubre su sector y declara su
        // multiplicador propio. El resolver geometrico del mat (al detectar
        // click en sector N) busca la apuesta nombrada con sectores:[N] y
        // emite SU id — backend liquida con SU multiplicador. Cero hardcodes.
        apuestas: [
            {
                id: 'argentina',
                grupo: 'pais',
                sectores: [1],
                multiplicador: 6,
                categoria: 'inside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'brasil',
                grupo: 'pais',
                sectores: [2],
                multiplicador: 6,
                categoria: 'inside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'uruguay',
                grupo: 'pais',
                sectores: [3],
                multiplicador: 14,
                categoria: 'inside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'mexico',
                grupo: 'pais',
                sectores: [4],
                multiplicador: 16,
                categoria: 'inside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'alemania',
                grupo: 'pais',
                sectores: [5],
                multiplicador: 9,
                categoria: 'inside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'francia',
                grupo: 'pais',
                sectores: [6],
                multiplicador: 7,
                categoria: 'inside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'espana',
                grupo: 'pais',
                sectores: [7],
                multiplicador: 9,
                categoria: 'inside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'inglaterra',
                grupo: 'pais',
                sectores: [8],
                multiplicador: 8,
                categoria: 'inside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'italia',
                grupo: 'pais',
                sectores: [9],
                multiplicador: 14,
                categoria: 'inside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'portugal',
                grupo: 'pais',
                sectores: [10],
                multiplicador: 10,
                categoria: 'inside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'paisesBajos',
                grupo: 'pais',
                sectores: [11],
                multiplicador: 12,
                categoria: 'inside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'belgica',
                grupo: 'pais',
                sectores: [12],
                multiplicador: 16,
                categoria: 'inside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'croacia',
                grupo: 'pais',
                sectores: [13],
                multiplicador: 16,
                categoria: 'inside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'estadosUnidos',
                grupo: 'pais',
                sectores: [14],
                multiplicador: 25,
                categoria: 'inside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'japon',
                grupo: 'pais',
                sectores: [15],
                multiplicador: 25,
                categoria: 'inside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'coreaDelSur',
                grupo: 'pais',
                sectores: [16],
                multiplicador: 25,
                categoria: 'inside',
                autorizable: true,
                activa: true,
            },
            // Apuestas por continente: cubren varios sectores, mismo mult
            // dentro del grupo -> la tabla las colapsa en 1 fila "CONTINENTE".
            {
                id: 'sudamerica',
                grupo: 'continente',
                sectores: [1, 2, 3],
                multiplicador: 5,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'centroamerica',
                grupo: 'continente',
                sectores: [4, 14],
                multiplicador: 5,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'europa',
                grupo: 'continente',
                sectores: [5, 6, 7, 8, 9, 10, 11, 12, 13],
                multiplicador: 5,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
            {
                id: 'asia',
                grupo: 'continente',
                sectores: [15, 16],
                multiplicador: 5,
                categoria: 'outside',
                autorizable: true,
                activa: true,
            },
        ],
        barrasDeStats: [],
        mat: {
            columnas: 4,
            botones: [
                { linea: 'sudamerica', seccion: 'inferior', paleta: 'paleta-0', tipografia: 'chance' },
                { linea: 'centroamerica', seccion: 'inferior', paleta: 'paleta-3', tipografia: 'chance' },
                { linea: 'europa', seccion: 'inferior', paleta: 'paleta-5', tipografia: 'chance' },
                { linea: 'asia', seccion: 'inferior', paleta: 'paleta-2', tipografia: 'chance' },
            ],
        },
        geometria: {
            radioInterior: 0.35,
            radioMedio: 0.6,
            radioExterior: 0.98,
            alturaDomo: 0.09, // casquete SUAVE, apenas más alto que el relieve central
            // El tramo del domo (r=0 hasta radioInterior) NO se declara acá — lo
            // calcula resolverPuntosDePerfil() desde alturaDomo (geometría del
            // casquete esférico, empalme garantizado por código, no por un z a mano).
            // El primer punto de este array es el primero DESPUÉS del domo.
            perfilRelieve: [
                { r: 0.475, z: -0.05 },
                { r: 'radioMedio', z: 0 },
                { r: 'radioExterior', z: 0.055 },
                { r: 1, z: 0 },
            ],
        },
    },
};

// ── RED DOOR — rueda propia (SPEC_lightning-bonus-reddoor.md) ────────────────────────────────
// MISMA rueda física que mega3000 (37 sectores, pleno recortado x20 que financia el bonus):
// clon profundo post-definición para no duplicar ~370 líneas de sectores/apuestas (SSOT de la
// rueda física — si mega3000 corrige un sector, reddoor lo hereda). Solo difiere el bloque
// lightning: mecánica ruedaBonus (keys frecuentes que abren puertas; la key JAMÁS paga sola).
// JSON deep-clone: la receta es data pura (sin funciones) — verificado.
RECETAS_AGNOSTICAS.reddoor = {
    ...JSON.parse(JSON.stringify(RECETAS_AGNOSTICAS.mega3000)),
    id: 'reddoor',
    lightning: {
        // Clon profundo también del preset: un spread shallow compartiría bonus/tiers POR
        // REFERENCIA con LIGHTNING_PRESETS.reddoor (mutación accidental cruzaría los dos).
        ...JSON.parse(JSON.stringify(LIGHTNING_PRESETS.reddoor)),
        // ACTIVA (2026-07-11) tras el gate completo: MC integrado 16/16 (RTP 85.44% en
        // banda, manada 86.09%, solvencia dura 0 excesos, costo==pago exacto — tools/
        // montecarlo-reddoor-integrado.js) + suites + golden 37/37. SEGURO en prod:
        // ningún sorteo de prod referencia esta receta (verificado en ambas DBs) — solo
        // vive en sorteos DEV creados con tipoRuleta 'reddoor'. rueda10 NUNCA se activa.
        activo: true,
    },
};
